import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import HomeView from "@/views/HomeView.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/home",
    redirect: { name: "home" },
    component: HomeView,
  },
  {
    path: "/por-que-columbia",
    name: "por-que-columbia",
    component: () => import("@/views/AboutView_1.vue"),
  },
  {
    path: "/nuestra-historia",
    name: "nuestra-historia",
    component: () => import("@/views/AboutView_2.vue"),
  },
  {
    path: "/nuestras-sedes",
    name: "nuestras-sedes",
    component: () => import("@/views/AboutView_3.vue"),
  },
  {
    path: "/columbiainstituto",
    name: "columbiainstituto",
    component: () => import("@/views/EducativeOffertView_1.vue"),
  },
  {
    path: "/hoteleriainternacional",
    name: "hoteleriainternacional",
    component: () => import("@/views/EducativeOffertView_2.vue"),
  },
  {
    path: "/altacocina",
    name: "altacocina",
    component: () => import("@/views/EducativeOffertView_3.vue"),
  },
  {
    path: "/bartender",
    name: "bartender",
    component: () => import("@/views/EducativeOffertView_4.vue"),
  },
  {
    path: "/pasteleriapanaderia",
    name: "pasteleriapanaderia",
    component: () => import("@/views/EducativeOffertView_5.vue"),
  },
  {
    path: "/columbiaonline",
    name: "columbiaonline",
    component: () => import("@/views/EducativeOffertView_6.vue"),
  },
  {
    path: "/columbiacetpro",
    name: "columbiacetpro",
    component: () => import("@/views/EducativeOffertView_7.vue"),
  },
  {
    path: "/aviacioncomercial",
    name: "aviacioncomercial",
    component: () => import("@/views/EducativeOffertView_8.vue"),
  },
  {
    path: "/partners",
    name: "partners",
    component: () => import("@/views/PartnersView.vue"),
  },
  {
    path: "/professionals",
    name: "professionals",
    component: () => import("@/views/ProfessionalsView.vue"),
  },
  {
    path: "/portal",
    name: "portal",
    component: () => import("@/views/PortalView.vue"),
  },
  {
    path: "/blog",
    name: "blog",
    component: () => import("@/views/BlogView.vue"),
  },
  {
    path: "/portal-de-transparencia",
    name: "portal-de-transparencia",
    component: () => import("@/views/PortalDeTransparenciaView.vue"),
  },
  {
    path: "/registrate",
    name: "registrate",
    component: () => import("@/components/Form.vue"),
  },
  {
    path: "/openDay2023",
    name: "openDay2023",
    component: () => import("@/components/OpenDay/Openday2023.vue"),
  },
  {
    path: "/CentroIdiomas",
    name: "CentroIdiomas",
    component: () => import("@/views/CentroIdiomaPrincipalView.vue"),
  },
  {
    path: "/Intrigacentrodeidiomas",
    name: "Intrigacentrodeidiomas",
    component: () => import("@/views/CentroIdiomaIntrigaView.vue"),
  },
  {
    path: "/ProgramaIngles",
    name: "ProgramaIngles",
    component: () => import("@/views/CentroIdiomaProgramaInglesView.vue"),
  },
  {
    path: "/LandingProgramaIngles",
    name: "LandingProgramaIngles",
    component: () => import("@/views/Landings/LandingProgramaInglesView.vue")
  },
  {
    path: "/LandingAltaCocina",
    name: "LandingAltaCocina",
    component: () => import("@/views/Landings/LandingAltaCocina.vue")
  },
  {
    path: "/LandingAviacionComercial",
    name: "LandingAviacionComercial",
    component: () => import("@/views/Landings/LandingAviacionComercial.vue")
  },
  {
    path: "/LandingHoteleria",
    name: "LandingHoteleria",
    component: () => import("@/views/Landings/LandingHoteleria.vue")
  },
  {
    path: "/Gracias",
    name: "Gracias",
    component: () => import("@/views/Gracias.vue")
  },
  {
    path: "/tramites-academicos",
    name: "/tramites-academicos",
    component: () => import("@/views/Tramites.vue")
  },
  {
    path: "/pre-columbia",
    name: "/pre-columbia",
    component: () => import("@/views/Landings/LandingPreColumbia.vue")
  },
  {
    path: "/openDay2024",
    name: "openDay2024",
    component: () => import("@/views/OpenDay/OpenDay2024.vue"),
  },
  {
    path: "/becas-columbia",
    name: "/becas-columbia",
    component: () => import("@/views/Landings/LandingBeca.vue")
  },
  {
    path: "/openFest",
    name: "/openFest",
    component: () => import("@/views/Landings/LandingOpenFest.vue")
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    return new Promise((resolve) => {
      if (to.hash) {
        setTimeout(() => {
          resolve({
            selector: to.hash,
            offset: { x: 0, y: 70 },
            behavior: "smooth",
          });
        }, 1000);
      } else {
        resolve({ x: 0, y: 0 });
      }
    });
  },
});

export default router;
